import React, { useRef } from "react";
import styles from "../../styles/australiavad.module.scss"
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import CustomImage from "../CustomImage"; 
import Slider from "react-slick";

interface Props {
    howToAttendEventData: any;

}
const settings = {
    infinite: true,
    arrows: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    responsive: [

        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: false,

            }
        },

        {
            breakpoint: 600,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                dotsClass: styles.sliderDots,
                dots: true,
            }
        }
    ]
};

const HowToAttendEvent: React.FC<Props> = ({ howToAttendEventData }) => {
    const sliderRef = useRef<Slider>(null);
    const cardData = howToAttendEventData?.attendCard;
    return (
        <div className={styles.howAttendevent} style={{ backgroundColor: howToAttendEventData?.sectionBgColor || "#FFFFFF" }}>
            <Container>
                <Row>
                    <div className={styles.heading}>
                        <h1>{howToAttendEventData?.sectionTitle}</h1>
                    </div>
                </Row>
                <Row>
                    {cardData.map((card: any) => (
                        <Col className={styles.desktopview}>
                            <div className={styles.imgDiv}>
                                <CustomImage src={card.cardImageUrl || "/images/testprep/parinita-yadav.png"} width={160} height={160} className={styles.cardImg} alt={howToAttendEventData?.mainImageUrl?.alt} />
                            </div>
                            <div className={styles.title}>
                                <h2> {card?.cardTitle}</h2>
                            </div>
                            <div className={styles.step}>
                                <p>{card?.cardDetail}</p>
                            </div>
                        </Col>
                    ))}
                    <div className={styles.mbSlider}>
                        <Slider {...settings} ref={sliderRef}>
                            {cardData.map((card: any) => (
                                <Col>
                                    <div className={styles.imgDiv}>
                                        <CustomImage src={card?.cardImageUrl || "/images/testprep/parinita-yadav.png"} width={160} height={160} className={styles.cardImg} alt={howToAttendEventData?.mainImageUrl?.alt} />
                                    </div>
                                    <div className={styles.title}>
                                        <h2> {card?.cardTitle}</h2>
                                    </div>
                                    <div className={styles.step}>
                                        <p>{card?.cardDetail}</p>
                                    </div>
                                </Col>
                            ))}
                        </Slider>
                    </div>

                </Row>
            </Container>
        </div >
    )
}
export default HowToAttendEvent; 